import React from 'react' // eslint-disable-line no-unused-vars
import '../../ui-elements/Modals'
import { Modal } from 'reactstrap'
import { RingLoader } from 'react-spinners'
import pdfjs from 'pdfjs-dist/webpack'

class DocumentModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
    this.scale = null
    this.pdf = null
    this.currentPage = 1

    this.MINSCALE = 0.2
    // default max scale
    // gets overwritten upon doc load to be 3 * initial scale
    this.MAXSCALE = 2
  }

  loadAllDocs = documentLink => {
    this.setState({ loading: true })
    pdfjs
      .getDocument({ url: documentLink, withCredentials: true })
      .promise.then(
        res => {
          this.pdf = res
          this.pdf
            .getPage(this.currentPage)
            .then(this.loadDoc)
            .then(() => {
              this.setState({ loading: false })
            })
        },
        () => { }
      )
    this.currentPage = 1
  };

  loadDoc = page => {
    const container = document.getElementById('doc-canvas-container')
    // get dimensions of current page
    if (!this.scale) {
      this.scale =
        (0.9 * window.innerWidth) / page.getViewport({ scale: 1.0 }).width
      this.MAXSCALE = this.scale.valueOf() * 3
    }
    const viewport = page.getViewport({ scale: this.scale })
    const canvas = document.createElement('canvas')
    canvas.className = 'doc-canvas'
    const canvasContext = canvas.getContext('2d')
    canvas.height = viewport.height
    canvas.width = viewport.width

    page.render({
      canvasContext,
      viewport
    })

    container.appendChild(canvas)

    this.currentPage++
    if (this.pdf !== null && this.currentPage <= this.pdf.numPages) {
      this.pdf.getPage(this.currentPage).then(this.loadDoc)
    }
  };

  handlePlus = () => {
    const container = document.getElementById('doc-canvas-container')
    this.currentPage = 1
    this.scale =
      parseFloat(this.scale) + 0.05 < this.MAXSCALE
        ? parseFloat(this.scale) + 0.05
        : this.MAXSCALE
    while (container.firstChild) {
      container.removeChild(container.firstChild)
    }
    this.pdf.getPage(this.currentPage).then(this.loadDoc)
  };

  handleMinus = () => {
    const container = document.getElementById('doc-canvas-container')
    this.currentPage = 1
    this.scale =
      parseFloat(this.scale) - 0.05 > this.MINSCALE
        ? parseFloat(this.scale) - 0.05
        : this.MINSCALE
    while (container.firstChild) {
      container.removeChild(container.firstChild)
    }
    this.pdf.getPage(this.currentPage).then(this.loadDoc)
  };

  componentDidMount () {
    this.loadAllDocs(this.props.documentLink)
  }

  render () {
    return (
      <div>
        <Modal
          isOpen
          toggle={this.props.closeDocumentModal}
          size='lg'
          className='doc-modal'
          contentClassName='doc-modal-content'
        >
          {this.state.loading ? null : (
            <div>
              <button onClick={this.handlePlus}>
                <span className='fa fa-plus' />
              </button>
              <button onClick={this.handleMinus}>
                <span className='fa fa-minus' />
              </button>
            </div>
          )}
          <div id='doc-canvas-container' />
          {this.state.loading ? (
            <div className='doc-ring-loader'>
              <RingLoader color='#071d49' loading />
            </div>
          ) : null}
        </Modal>
      </div>
    )
  }
}

export default DocumentModal



// WEBPACK FOOTER //
// ./src/mi-app/modals/DocumentModal.js